<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100 transition-all duration-300"
    :class="{ 'collapsed-sidebar': isCollapsed }"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- Dashboard -->
      <li
        class="nav-item"
        v-if="dataManagerModule && dataManagerModule.is_dashboard"
      >
        <sidenav-collapse-item
          :text="isCollapsed ? '' : $t('Dashboard')"
          :miniIcon="'home'"
          sidenavKey="33"
          :collapseRef="`/home`"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? $t('Dashboard') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/home`"
                :navText="$t('Home')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                    >home</i
                  >
                </template>
              </sidenav-collapse>
            </li>
            <sidenav-collapse-item
              text="Business Insights <br> <span style='font-size: 12px;'>(Premium Features) *</span>"
              miniIcon="dashboard"
              sidenavKey="34"
              :isCollapsed="isCollapsed"
              :collapseRef="`/business-insight/all-outlet-total-revenue`"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/business-insight/all-outlet-total-revenue`"
                    navText="All Outlet Total Revenue"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/business-insight/hourly-sales-heatmap`"
                    navText="Hourly Sales Heatmap"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/business-insight/item-performance`"
                    navText="Item Performance"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/business-insight/branch-comparison`"
                    navText="Branch Comparison"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/business-insight/daily-sales-summary`"
                    navText="Daily Sales Summary"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/business-insight/item-analytics`"
                    navText="Item Analytics"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- Booking -->
      <li class="nav-item">
        <sidenav-collapse-item
          :text="isCollapsed ? '' : $t('Booking')"
          miniIcon="calendar_month"
          sidenavKey="2223"
          :collapseRef="`/booking/calendar`"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? $t('Booking') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/booking/calendar`"
                :navText="$t('AppointmentCalendar')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/booking/management`"
                :navText="$t('BookingManagement')"
              >
              </sidenav-collapse>
            </li>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- Loyalty Members -->
      <li
        class="nav-item"
        v-if="dataManagerModule && dataManagerModule.is_loyalty_members"
      >
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          :collapseRef="`/members`"
          :navText="isCollapsed ? '' : $t('Loyalty Members')"
          :class="{ 'collapsed-item': isCollapsed }"
          :title="isCollapsed ? $t('Loyalty Members') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:icon>
            <i
              class="material-icons-round opacity-10 fs-5"
              @click="toggleSidebar()"
              >groups</i
            >
          </template>
        </sidenav-collapse>
      </li>

      <!-- Menu -->
      <li class="nav-item">
        <sidenav-collapse-item
          :text="isCollapsed ? '' : $t('Items')"
          miniIcon="menu"
          sidenavKey="5"
          :collapseRef="`/menu-set`"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? $t('Items') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/menu-set`"
                :navText="$t('Menu Set')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/modifiers`"
                navText="Modifiers"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/items`"
                navText="Item Master List"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/option-group`"
                navText="Option Groups"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/report-group`"
                :navText="$t('Report Group & Type')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/menu-set/printers`"
                :navText="$t('Printers')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/menu-set/export`"
                :navText="$t('Export')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/menu-set/import`"
                :navText="$t('Import')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/menu-set/import-json`"
                :navText="$t('Import JSON')"
              >
              </sidenav-collapse>
            </li>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- Inventory -->
      <li class="nav-item">
        <sidenav-collapse-item
          :text="isCollapsed ? '' : $t('Inventory')"
          miniIcon="dashboard"
          sidenavKey="6"
          :collapseRef="`/inventory`"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? $t('Inventory') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/inventory`"
                navText="Overview"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/inventory/stock-in-out`"
                navText="Stock In/Out"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/inventory/stock-transfers`"
                navText="Stock Transfers"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/inventory/stock-transfer`"
                navText="Stock Transfer"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/inventory/stock-movement-summary-report`"
                navText="Stock Movement Summary"
              >
              </sidenav-collapse>
            </li>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- MEGAPOS POS Report -->
      <li class="nav-item">
        <sidenav-collapse-item
          :text="isCollapsed ? '' : 'MEGAPOS Data'"
          miniIcon="dashboard"
          sidenavKey="333"
          :collapseRef="`/analytics/pos-daily-collections`"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? 'MEGAPOS Data' : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/analytics/pos-daily-collections`"
                navText="POS Daily Collection"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/analytics/item-details-by-channel`"
                navText="Item Details by Channel"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/analytics/recipe-usage`"
                navText="Recipe Usage Report"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-transaction-by-branch`"
                navText="Transactions By Branch"
              >
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="
                dataManagerModule && dataManagerModule.is_pos_transaction
              "
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-pos-transaction`"
                :navText="$t('POSTransaction')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-sales-with-modifiers`"
                    navText="Item Sales with Modifiers"
                  >
                  </sidenav-collapse>
                </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/analytics/collection-by-branch`"
                navText="Collection By Branch"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/analytics/category-sales`"
                navText="Category Sales Report"
              >
              </sidenav-collapse>
            </li>
            <sidenav-collapse-item
              :text="$t('TxnLevelReports')"
              sidenavKey="3331"
              :collapseRef="
                dataManagerModule && dataManagerModule.is_pos_transaction
                  ? `/dashboard-reports-pos-transaction`
                  : `/dashboard-reports-online-ordering`
              "
            >
              <template v-slot:nav-child-item>
                <li
                  class="nav-item"
                  v-if="
                    dataManagerModule && dataManagerModule.is_pos_transaction
                  "
                >
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/dashboard-reports-pos-transaction`"
                    :navText="$t('POSTransaction')"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/dashboard-reports-online-ordering`"
                    :navText="$t('PaidOnlineOrders')"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/dashboard-reports-kiosk`"
                    :navText="$t('PaidKioskOrders')"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/dashboard-reports-pickup-items`"
                    navText="Pickup Items"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/hourly-sales-by-branch`"
                    navText="Hourly Sales by Branch"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>

            <sidenav-collapse-item
              :text="$t('ItemReports')"
              sidenavKey="3332"
              :collapseRef="`/analytics/item-sales`"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-sales`"
                    navText="Item Sales Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-details-by-channel`"
                    navText="Item Details by Channel"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-sales-by-price`"
                    navText="Item Sales By Price"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/production-report`"
                    navText="Production Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/items-by-receipt`"
                    navText="Item Sales by Receipt"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-sales-modifiers`"
                    navText="Modifier Sales by 1 Item"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-sales-modifiers-new`"
                    navText="Modifier Sales by All Items"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-sales-by-group-daily`"
                    navText="Item Sales By Group"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>

            <sidenav-collapse-item
              :text="$t('DiscountFOC')"
              sidenavKey="3333"
              :collapseRef="`/analytics/item-discount-report`"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-discount-report`"
                    navText="Item Discount Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/bill-discount-report`"
                    navText="Bill Discount Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-foc-report`"
                    navText="Item FOC Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/bill-foc-report`"
                    navText="Bill FOC Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-voided-report`"
                    navText="Item Voided Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/bill-voided-report`"
                    navText="Bill Voided Report"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>

            <sidenav-collapse-item
              :text="$t('CustomReports')"
              sidenavKey="3334"
              :collapseRef="`/analytics/pricing-analysis`"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/pricing-analysis`"
                    navText="Pricing Analysis"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/staff-clock-in-out`"
                    navText="Staff Clock In/Out"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/daily-revenue`"
                    navText="Daily Revenue"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/item-sales-detail`"
                    navText="Item Sales Detail"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>

            <sidenav-collapse-item
              text="Commission Report"
              sidenavKey="3335"
              :collapseRef="`/analytics/commission-report`"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/commission-report`"
                    navText="Commission Report"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/service-commission`"
                    navText="Service Commission"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/analytics/product-commission`"
                    navText="Product Commission"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/analytics/report-builder`"
                :navText="$t('rb_title')"
              >
              </sidenav-collapse>
            </li>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- CRM Report -->
      <li
        class="nav-item"
        v-if="dataManagerModule && dataManagerModule.is_reports"
      >
        <sidenav-collapse-item
          :text="isCollapsed ? '' : $t('CRM Report')"
          miniIcon="dashboard"
          sidenavKey="2"
          :collapseRef="`/dashboard-reports`"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? $t('CRM Report') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <li
              class="nav-item"
              v-if="
                dataManagerModule && dataManagerModule.is_voucher_redemption
              "
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports`"
                :navText="$t('VoucherRedemption')"
              >
              </sidenav-collapse>
            </li>
            <!-- Other CRM Report items... -->
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_topup"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-top-up`"
                :navText="$t('TopupReports')"
              >
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_void_topup"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-void-top-up`"
                :navText="$t('VoidTopupReports')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-wallet`"
                :navText="$t('WalletReports')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-expiry`"
                :navText="$t('Expiry Report')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-member-balance-points`"
                :navText="$t('MemberBalancePointsReports')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-point`"
                :navText="$t('PointReports')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-paid-membership`"
                :navText="$t('PaidMembership')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-member-voucher`"
                :navText="$t('MemberVoucherReports')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-order-item`"
                :navText="$t('OrderItem')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-donation`"
                :navText="$t('DonationReports')"
              >
              </sidenav-collapse>
            </li>
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-reports-wa-message`"
                :navText="$t('WhatsAppReports')"
              >
              </sidenav-collapse>
            </li>

            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-daily-payment-summary`"
                :navText="$t('Daily Payment Summary')"
              >
              </sidenav-collapse>
            </li>

            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/dashboard-un-uploaded-receipts`"
                :navText="$t('Un Uploaded Receipt')"
              >
              </sidenav-collapse>
            </li>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- Productivity Tools -->
      <li class="nav-item">
        <sidenav-collapse-item
          :text="isCollapsed ? '' : $t('Productivity Tools')"
          miniIcon="build"
          sidenavKey="222"
          :collapseRef="`/test`"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? $t('Productivity Tools') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <!-- POS Simulator -->
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_pos_simulator"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/test`"
                :navText="$t('POS Simulator')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                    >shopping_cart_checkout</i
                  >
                </template>
              </sidenav-collapse>
            </li>

            <!-- ERP Integration -->
            <sidenav-collapse-item
              :text="$t('ERP Integration')"
              miniIcon="dashboard"
              sidenavKey="2221"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/erp/login-credentials`"
                    navText="ERP/Accounting"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/erp/pos-data-for-erp`"
                    navText="POS Data For ERP"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/erp/erp-draft`"
                    navText="ERP Draft"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/erp/erp-invoice`"
                    navText="ERP Invoice"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>

            <!-- Payment -->
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_payment"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/payments`"
                :navText="$t('Payment')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                    >payments</i
                  >
                </template>
              </sidenav-collapse>
            </li>

            <!-- Promo Code -->
            <li
              class="nav-item"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/promo-codes`"
                :navText="'Promo Code'"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                    >redeem</i
                  >
                </template>
              </sidenav-collapse>
            </li>

            <!-- Bulk Voucher Issuance -->
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/bulk-voucher-issuance`"
                :navText="$t('Bulk Voucher Issuance')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                    >redeem</i
                  >
                </template>
              </sidenav-collapse>
            </li>

            <!-- Marketing -->
            <sidenav-collapse-item
              :text="$t('Marketing')"
              miniIcon="campaign"
              sidenavKey="2222"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/`"
                    :navText="$t('WA_Marketing')"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/marketing/campaigns`"
                    :navText="$t('Campaign')"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/marketing/wa-marketing-templates`"
                    :navText="$t('WA_Template')"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>

            <!-- Product -->
            <sidenav-collapse-item
              :text="$t('Product')"
              miniIcon="storefront"
              sidenavKey="2224"
            >
              <template v-slot:nav-child-item>
                <li
                  class="nav-item"
                  v-if="dataManagerModule && dataManagerModule.is_product_list"
                >
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/products`"
                    navText="Product List"
                  >
                    <template v-slot:icon>
                      <i
                        class="material-icons-round opacity-10 fs-5"
                        @click="toggleSidebar()"
                      ></i>
                    </template>
                  </sidenav-collapse>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    dataManagerModule && dataManagerModule.is_product_group_list
                  "
                >
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/group`"
                    navText="Product Group List"
                  >
                    <template v-slot:icon>
                      <i
                        class="material-icons-round opacity-10 fs-5"
                        @click="toggleSidebar()"
                      ></i>
                    </template>
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>

            <!-- Stripe Reader -->
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_payment"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/stripe-reader`"
                :navText="$t('Stripe Reader')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                    >chrome_reader_mode</i
                  >
                </template>
              </sidenav-collapse>
            </li>

            <!-- Subscription -->
            <li
              class="nav-item"
              v-if="
                nodeEnv === 'staging' &&
                dataManagerModule &&
                dataManagerModule.is_subscription
              "
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/subscriptions`"
                :navText="$t('Subscription')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                    >subscriptions</i
                  >
                </template>
              </sidenav-collapse>
            </li>

            <!-- Language -->
            <sidenav-collapse-item
              :text="$t('language')"
              miniIcon="language"
              sidenavKey="2225"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <a
                    @click="changeLanguage('en')"
                    href="javascript:void(0)"
                    class="nav-link"
                    data-bs-toggle=""
                    aria-controls=""
                    aria-expanded="false"
                  >
                    <span class="nav-link-text ms-1">English</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    @click="changeLanguage('cn')"
                    href="javascript:void(0)"
                    class="nav-link"
                    data-bs-toggle=""
                    aria-controls=""
                    aria-expanded="false"
                  >
                    <span class="nav-link-text ms-1">Chinese</span>
                  </a>
                </li>
              </template>
            </sidenav-collapse-item>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- Setting -->
      <li
        class="nav-item"
        v-if="dataManagerModule && dataManagerModule.is_setting"
      >
        <sidenav-collapse-item
          :text="isCollapsed ? '' : $t('Setting')"
          miniIcon="settings"
          sidenavKey="111"
          :isCollapsed="isCollapsed"
          :tooltip="isCollapsed ? $t('Setting') : ''"
          @click="isCollapsed ? handleToggleCollapse() : ''"
        >
          <template v-slot:nav-child-item v-if="!isCollapsed">
            <sidenav-collapse-item
              :text="$t('General')"
              sidenavKey="1111"
              :collapseRef="`/general-setting`"
            >
              <template v-slot:nav-child-item>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/general-setting`"
                    navText="MOO"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/kiosk-general-setting`"
                    navText="KIOSK"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/grabfood-general-setting`"
                    navText="GrabFood"
                  >
                  </sidenav-collapse>
                </li>
                <li class="nav-item">
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/pos-general-setting`"
                    navText="POS"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_cashback"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/cashback-setting`"
                :navText="$t('Cashback')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_point"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/point-setting`"
                :navText="$t('Point')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_discount"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/discounts`"
                :navText="$t('Discount')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_voucher_set"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/vouchers`"
                :navText="$t('Vouchers')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_voucher_set"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/vouchers-bundle`"
                :navText="$t('Voucher_Bundle')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_tier"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/tier-setting`"
                :navText="$t('Tier')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <sidenav-collapse-item :text="$t('Slides')" sidenavKey="1112">
              <template v-slot:nav-child-item>
                <li
                  class="nav-item"
                  v-if="dataManagerModule && dataManagerModule.is_slides"
                >
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/slide-setting`"
                    :navText="$t('Slider Images')"
                  >
                    <template v-slot:icon>
                      <i
                        class="material-icons-round opacity-10 fs-5"
                        @click="toggleSidebar()"
                      ></i>
                    </template>
                  </sidenav-collapse>
                </li>
                <li
                  class="nav-item"
                  v-if="dataManagerModule && dataManagerModule.is_slide_show"
                >
                  <sidenav-collapse
                    url="#"
                    :aria-controls="''"
                    v-bind:collapse="false"
                    :collapseRef="`/dashboard-reports-slides-show`"
                    :navText="$t('SlideShow')"
                  >
                  </sidenav-collapse>
                </li>
              </template>
            </sidenav-collapse-item>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_branches"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/branches`"
                :navText="$t('Sales_Channel')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <!-- M1084: Testing Account flag per physical branch. -->
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_branches"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/physical-branches`"
                :navText="$t('Physical_Branches')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_top_up"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/top-up`"
                :navText="$t('TopUp')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_sms"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/sms-and-wa-setup`"
                :navText="$t('SMS_and_WA')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <li
              class="nav-item"
              v-if="dataManagerModule && dataManagerModule.is_sms"
            >
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/email-setup`"
                :navText="$t('Email')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
            <!-- M891. Last, and not under General: the file it writes covers every screen above
                 it, not just the MOO settings it started out as. -->
            <li class="nav-item">
              <sidenav-collapse
                url="#"
                :aria-controls="''"
                v-bind:collapse="false"
                :collapseRef="`/settings-export-import`"
                :navText="$t('Export_Import')"
              >
                <template v-slot:icon>
                  <i
                    class="material-icons-round opacity-10 fs-5"
                    @click="toggleSidebar()"
                  ></i>
                </template>
              </sidenav-collapse>
            </li>
          </template>
        </sidenav-collapse-item>
      </li>

      <!-- Logout -->
      <li class="nav-item">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          :collapseRef="`/sign-in`"
          @click="logOut()"
          :navText="isCollapsed ? '' : $t('logout')"
          :class="{ 'collapsed-item': isCollapsed }"
          :title="isCollapsed ? $t('logout') : ''"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">login</i>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import SidenavCollapseItem from "./SidenavCollapseItem.vue";
import { mapMutations, mapState } from "vuex";
import ModuleService from "../../services/module.service";
import EventBus from "vue3-eventbus";
import $ from "jquery";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  components: {
    SidenavCollapse,
    SidenavCollapseItem,
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
      merchantCode: "",
      nodeEnv: process.env.VUE_APP_NODE_ENV,
      dataManagerModule: [],
    };
  },
  mounted() {
    const code = localStorage.getItem("MERCHANT_CODE", "");
    this.merchantCode = code ? `/${code}` : "";
    this.getModule();

    EventBus.on("ReloadSidenav", () => {
      this.getModule();
    });

    // Add click event listeners to all menu items
    this.$nextTick(() => {
      this.addMenuClickListeners();
    });
  },
  computed: {
    ...mapState(["isCollapsed"]),
  },
  beforeUnmount() {
    // Clean up event listeners
    this.removeMenuClickListeners();
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator", "toggleCollapse"]),
    toggleSidebar() {
      this.navbarMinimize();
      this.removeModalBackdrop();
    },
    handleToggleCollapse() {
      $(".sidenav-collapse-item").removeClass("show");
      this.toggleCollapse();
      this.removeModalBackdrop();
    },
    logOut() {
      this.toggleCollapse(false);
      this.$store.dispatch("auth/logout");
      $(".main-content").css("margin-left", 0);
      localStorage.setItem("logout-event", Date.now());
      this.removeModalBackdrop();
    },
    changeLanguage(language) {
      localStorage.setItem("locale", language);
      this.$i18n.locale = language;
      this.removeModalBackdrop();
    },
    getModule() {
      ModuleService.getModule().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.dataManagerModule = response.data.data;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    removeModalBackdrop() {
      // Remove modal backdrop elements
      const modalBackdrops = document.querySelectorAll(
        ".modal-backdrop.fade.show"
      );
      modalBackdrops.forEach((backdrop) => {
        backdrop.remove();
      });

      // Also remove any modal-backdrop elements without the 'show' class
      const allModalBackdrops = document.querySelectorAll(".modal-backdrop");
      allModalBackdrops.forEach((backdrop) => {
        backdrop.remove();
      });
    },
    addMenuClickListeners() {
      // Remove existing listeners first to prevent duplicates
      this.removeMenuClickListeners();

      // Add click event listeners to all sidenav-collapse elements
      const menuItems = document.querySelectorAll(".sidenav-collapse");
      menuItems.forEach((item) => {
        const clickHandler = () => {
          this.removeModalBackdrop();
        };
        item.addEventListener("click", clickHandler);
        // Store reference for cleanup
        item._modalBackdropHandler = clickHandler;
      });

      // Add click event listeners to all sidenav-collapse-item elements
      const collapseItems = document.querySelectorAll(".sidenav-collapse-item");
      collapseItems.forEach((item) => {
        const clickHandler = () => {
          this.removeModalBackdrop();
        };
        item.addEventListener("click", clickHandler);
        // Store reference for cleanup
        item._modalBackdropHandler = clickHandler;
      });

      // Add click event listeners to all nav-link elements
      const navLinks = document.querySelectorAll(".nav-link");
      navLinks.forEach((link) => {
        const clickHandler = () => {
          this.removeModalBackdrop();
        };
        link.addEventListener("click", clickHandler);
        // Store reference for cleanup
        link._modalBackdropHandler = clickHandler;
      });
    },
    removeMenuClickListeners() {
      // Remove event listeners from sidenav-collapse elements
      const menuItems = document.querySelectorAll(".sidenav-collapse");
      menuItems.forEach((item) => {
        if (item._modalBackdropHandler) {
          item.removeEventListener("click", item._modalBackdropHandler);
          delete item._modalBackdropHandler;
        }
      });

      // Remove event listeners from sidenav-collapse-item elements
      const collapseItems = document.querySelectorAll(".sidenav-collapse-item");
      collapseItems.forEach((item) => {
        if (item._modalBackdropHandler) {
          item.removeEventListener("click", item._modalBackdropHandler);
          delete item._modalBackdropHandler;
        }
      });

      // Remove event listeners from nav-link elements
      const navLinks = document.querySelectorAll(".nav-link");
      navLinks.forEach((link) => {
        if (link._modalBackdropHandler) {
          link.removeEventListener("click", link._modalBackdropHandler);
          delete link._modalBackdropHandler;
        }
      });
    },
  },
};
</script>

<style scoped>
.business-insights-container {
  margin-left: 20px;
}
</style>
